import React from 'react';
import { Button, ButtonWithLoading } from '@spark/ui-components/components/Button';
import Icon from '@spark/ui-components/components/Icon';
import Tooltip from '@spark/ui-components/components/Tooltip';
import { formatarDataSimples, formatarValorBRL } from '@spark/utils/formatters';

export const getTabelaPrecoColumns = (onSelect, onEdit, loadingEditId) => [
  {
    id: 'id',
    accessorKey: 'id',
    header: 'ID',
    size: 80,
    cell: ({ row }) => row.original.id ?? '-'
  },
  {
    id: 'nome',
    accessorKey: 'nomeTabelaPrecoDeposito',
    header: 'Nome',
    size: 220,
    cell: ({ row }) => row.original.nomeTabelaPrecoDeposito || '-'
  },
  {
    id: 'nomeResponsavel',
    accessorKey: 'nomeResponsavel',
    header: 'Nome Responsavel',
    size: 200,
    cell: ({ row }) => row.original.nomeResponsavel || '-'
  },
  {
    id: 'valorUnPallet',
    accessorKey: 'valorUnPallet',
    header: 'Valor Pallet',
    size: 120,
    cell: ({ row }) => {
      const value = row.original.valorUnPallet;
      return value === null || value === undefined ? '-' : formatarValorBRL(value);
    }
  },
  {
    id: 'valorUnEtiqueta',
    accessorKey: 'valorUnEtiqueta',
    header: 'Valor Etiqueta',
    size: 120,
    cell: ({ row }) => {
      const value = row.original.valorUnEtiqueta;
      return value === null || value === undefined ? '-' : formatarValorBRL(value);
    }
  },
  {
    id: 'valorUnArmazenagemPallet',
    accessorKey: 'valorUnArmazenagemPallet',
    header: 'Valor Arm. Pallet',
    size: 140,
    cell: ({ row }) => {
      const value = row.original.valorUnArmazenagemPallet;
      return value === null || value === undefined ? '-' : formatarValorBRL(value);
    }
  },
  {
    id: 'freetime',
    accessorKey: 'freetime',
    header: 'Freetime',
    size: 90,
    cell: ({ row }) => row.original.freetime ?? '-'
  },
  {
    id: 'cobrarPaletizacaoRetrabalho',
    accessorKey: 'cobrarPaletizacaoRetrabalho',
    header: 'Retr. palet.',
    size: 100,
    cell: ({ row }) => (row.original.cobrarPaletizacaoRetrabalho === true ? 'Sim' : 'Nao')
  },
  {
    id: 'cobrarEtiquetagemRetrabalho',
    accessorKey: 'cobrarEtiquetagemRetrabalho',
    header: 'Retr. etiqueta',
    size: 110,
    cell: ({ row }) => (row.original.cobrarEtiquetagemRetrabalho === true ? 'Sim' : 'Nao')
  },
  {
    id: 'dataVigenciaInicio',
    accessorKey: 'dataVigenciaInicio',
    header: 'Vigencia Inicio',
    size: 130,
    cell: ({ row }) =>
      row.original.dataVigenciaInicio ? formatarDataSimples(row.original.dataVigenciaInicio) : '-'
  },
  {
    id: 'dataVigenciaFim',
    accessorKey: 'dataVigenciaFim',
    header: 'Vigencia Fim',
    size: 130,
    cell: ({ row }) =>
      row.original.dataVigenciaFim ? formatarDataSimples(row.original.dataVigenciaFim) : '-'
  },
  {
    id: 'acoes',
    header: 'Selecionar',
    size: 120,
    cell: ({ row }) => (
      <div style={{ display: 'flex', gap: 8 }}>
        <Tooltip dir="top" text="Selecionar">
          <span className="d-inline-block">
            <Button
              variant="primary"
              size="sm"
              onClick={(event) => {
                event.stopPropagation();
                onSelect(row.original);
              }}
            >
              <Icon name="check" size={16} />
            </Button>
          </span>
        </Tooltip>
        {onEdit && (
          <Tooltip dir="top" text="Editar">
            <span className="d-inline-block">
              <ButtonWithLoading
                variant="outline-primary"
                size="sm"
                loading={loadingEditId === row.original.id}
                disabled={loadingEditId === row.original.id}
                onClick={(event) => {
                  event.stopPropagation();
                  onEdit(row.original.id);
                }}
              >
                <Icon name="pencil" size={16} />
              </ButtonWithLoading>
            </span>
          </Tooltip>
        )}
      </div>
    ),
    enableSorting: false
  }
];
